import React, { useEffect, useRef, useState } from 'react';
// import "./productDetails.scss";
import { Card, CardBody, Row } from 'reactstrap';
import { ProductDetailsForm } from '../../components/listings/ProductDetailsForm';
import { ProductImages } from '../../components/listings/ProductImages';
import { Colxx } from '../../components/common/CustomBootstrap';
import { productEditingModes } from '../../constants/productApproval';
import { statusesData } from './statusesData';
import { Status } from '../../constants/status';
import { useUserContext } from '../../context/UserContext';
import { CustomCardHeader } from '../../components/common/custom-card-header/CustomCardHeader';
import { MEMBER_SUBSCRIPTION_STATUS } from '../../constants/appConst';
import { NotificationManager } from '../../components/common/react-notifications';

export const ListingModalContent = ({
  productData = {},
  updateProductDetails,
  detailPageButtonStates,
  updateProductStatus,
  editingMode,
  handleAddNewProduct,
  deleteProduct,
  onCloseModal,
  isSM,
}) => {
  const [images, setImages] = useState([]); // product images
  const formikRef = useRef(null); // form ref
  const { user } = useUserContext();

  // add new helper states
  const [clickedButtonIndex, setClickedButtonIndex] = useState('');
  const [targetStatus, setTargetStatus] = useState('');
  const [imageAddError, setImageAddError] = useState(null);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  // handlers
  const handleFooterButtonClick = (buttonIndex, target) => {
    if (target === Status.deleted) {
      const data = {
        id: productData.id,
      };
      deleteProduct(buttonIndex, data);
    } else if (editingMode === productEditingModes.ADD_NEW) {
      if (
        user?.member_status === MEMBER_SUBSCRIPTION_STATUS.PAUSED &&
        target === Status.applied_c
      ) {
        NotificationManager.warning({
          message: 'After resume your subscription, you can add new product.',
        });
      } else {
        setClickedButtonIndex(buttonIndex);
        setTargetStatus(target);

        if (images.length < 2) {
          window.scrollTo(0, 0);
          setImageAddError('Please upload at least two images');
        } else {
          setImageAddError(null);
          if (formikRef.current) {
            formikRef.current.handleSubmit();
          }
        }
      }
    } else {
      if (
        user?.member_status === MEMBER_SUBSCRIPTION_STATUS.PAUSED &&
        target === Status.applied_c
      ) {
        NotificationManager.warning({
          message: 'After resume your subscription, you can submit product.',
        });
      } else {
        // will do update
        const data = {
          id: productData.id,
          status: target,
          user_id: user.id,
        };
        if (images.length < 2) {
          setImageAddError('Please upload at least two images');
        } else {
          setImageAddError(null);
        }
        updateProductStatus(buttonIndex, data);
      }
    }
  };
  const handleProductDetailsChange = (values) => {
    if (editingMode === productEditingModes.ADD_NEW) {
      let buttonIndex = clickedButtonIndex;
      values.status = targetStatus;
      handleAddNewProduct(buttonIndex, values, images);

      setClickedButtonIndex('');
      setTargetStatus('');
    } else {
      if (images.length < 2) {
        setImageAddError('Please upload at least two images');
      } else {
        updateProductDetails(values, 'buttonUpdate');
      }
    }
  };

  let statusData = statusesData[productData.status ?? Status.unsaved];

  // Show/Hide controlling flags
  const showProductStatus = editingMode !== productEditingModes.ADD_NEW;
  const showProductHeader = editingMode !== productEditingModes.ADD_NEW;
  const showStatusUpdateButtons =
    statusData && statusData.buttons && statusData.buttons.length > 0;

  //
  console.log('Endet', editingMode);

  return (
    <>
      {/* {showProductHeader && (
        <ProductDetailHeader
          title={productData.title}
          subTitle={`Consigned On ${getFormattedDateString(
            productData.consigned_on
          )}`}
        />
      )} */}

      <Row className='mt-4'>
        <Colxx xxs='12'>
          <Card
            // border='light'
            className='no-shadow wallet-cash-wrapper'
            style={{
              border: `1px solid #2E2B2B`,
              backgroundColor: 'transparent',
              marginBottom: '3.5rem',
            }}
          >
            <CustomCardHeader title='UPLOAD YOUR PICTURES' />
            <CardBody
              style={{
                paddingTop: isSM ? 20 : 32,
                paddingBottom: isSM ? 20 : 32,
                fontFamily: 'Brown',
              }}
            >
              <ProductImages
                productId={productData.id}
                editingMode={editingMode}
                imageAddError={imageAddError}
                isAllowAddImage={
                  Object.keys(productData).length === 0
                    ? true
                    : productData.status === Status.draft_by_lender
                }
                onImagesChanged={(imgs) => {
                  setImageAddError(null);
                  setImages(imgs);
                }}
                isSM={isSM}
              />
            </CardBody>
          </Card>

          <ProductDetailsForm
            handleSubmit={handleProductDetailsChange}
            productData={productData}
            isUpdating={
              detailPageButtonStates.updatingButton === 'buttonUpdate'
            }
            imageAddError={imageAddError}
            submitDisabled={
              detailPageButtonStates.updatingButton === 'buttonUpdate'
            }
            editingMode={editingMode}
            formikRef={formikRef}
            isSM={isSM}
            detailPageButtonStates={detailPageButtonStates}
            handleFooterButtonClick={handleFooterButtonClick}
            onCloseModal={onCloseModal}
          />
          {/* <div
            className='d-flex align-items-center justify-content-center'
            style={{ flexDirection: 'column' }}
          >
            {statusData.buttons.map((statusButton) => {
              const buttonId = statusButton.id;
              if (!statusButton.isLinkButton) {
                return (
                  <ButtonWithLoadingIcon
                    key={buttonId}
                    disabled={detailPageButtonStates.updatingButton !== ''}
                    loading={detailPageButtonStates.updatingButton === buttonId}
                    color='primary'
                    size='lg'
                    className={'mb-2'}
                    onClick={() =>
                      handleFooterButtonClick(buttonId, statusButton.target)
                    }
                  >
                    {statusButton.name}
                  </ButtonWithLoadingIcon>
                );
              } else {
                return (
                  <div className={'mt-3 d-flex align-items-center'}>
                    <LinkButton
                      onClick={() => {
                        if (onCloseModal) {
                          onCloseModal();
                        }
                      }}
                    >
                      Cancel
                    </LinkButton>
                    <span className='mx-2'>or</span>
                    <LinkButton
                      onClick={() => {
                        handleFooterButtonClick(buttonId, statusButton.target);
                      }}
                    >
                      {statusButton.name}
                    </LinkButton>
                  </div>
                );
              }
            })}
            {!statusData.isNewForm ? (
              <LinkButton
                onClick={() => {
                  if (onCloseModal) {
                    onCloseModal();
                  }
                }}
              >
                Cancel
              </LinkButton>
            ) : null}
          </div> */}
        </Colxx>
        {/* <Colxx xxs='12' md='8' xl='8' lg='8' className='mb-4'>
          {showProductStatus && (
            <>
              <p
                className='capitalize'
                style={{
                  color: 'black',
                  fontWeight: 'bold',
                  fontFamily: 'Brown',
                }}
              >
                STATUS:{' '}
                <strong
                  className='text-uppercase'
                  style={{ fontWeight: 'normal' }}
                >
                  {productData.status
                    ? getFormattedStatus(
                        productData.status === Status.draft_by_lender
                          ? Status.draft
                          : productData.status
                      )
                    : ''}
                </strong>
              </p>

              {productData.status === 'listed' && (
                <div className='capitalize mb-2'>
                  <a
                    href={productData.shopify_product_url}
                    className='btn-link'
                    color='link'
                  >
                    See on Store
                  </a>
                </div>
              )}
            </>
          )}
        </Colxx> */}
        {/* <Colxx xxs='12' md='8' lg='8' xl='8' className='mb-4'>
          <ProductImages
            productId={productData.id}
            editingMode={editingMode}
            imageAddError={imageAddError}
            isAllowAddImage={
              Object.keys(productData).length === 0
                ? true
                : productData.status === Status.draft_by_lender
            }
            onImagesChanged={(imgs) => {
              setImageAddError(null);
              setImages(imgs);
            }}
          />
        </Colxx> */}

        {/* <Colxx xxs='12' md='8' xl='8' lg='8' className='mb-4'>
          <ProductDetailsForm
            handleSubmit={handleProductDetailsChange}
            productData={productData}
            isUpdating={
              detailPageButtonStates.updatingButton === 'buttonUpdate'
            }
            imageAddError={imageAddError}
            submitDisabled={
              detailPageButtonStates.updatingButton === 'buttonUpdate'
            }
            editingMode={editingMode}
            formikRef={formikRef}
          />
        </Colxx> */}

        {/* <Colxx xxs='12'>
          {showStatusUpdateButtons && (
            <ModalFooter>
              {statusData.buttons.map((statusButton) => {
                const buttonId = statusButton.id;
                return (
                  <ButtonWithLoadingIcon
                    key={buttonId}
                    disabled={detailPageButtonStates.updatingButton !== ''}
                    loading={detailPageButtonStates.updatingButton === buttonId}
                    color='primary'
                    size='lg'
                    onClick={() =>
                      handleFooterButtonClick(buttonId, statusButton.target)
                    }
                  >
                    {statusButton.name}
                  </ButtonWithLoadingIcon>
                );
              })}
            </ModalFooter>
          )}
        </Colxx> */}
      </Row>
    </>
  );
};
